import React from 'react';
import { useRouter } from '../../../../../../@casino/useRouter';
import classes from './style.module.css';

const GameItem = ({
    id,
    image,
    provider,
    is_disabled,
    name
}) => {
    const router = useRouter();
    const handleClick = () => {
        router.history.push(`/games/edit/${id}`)
    }

    return (
        <div
            onDoubleClick={handleClick}
            className={classes.game}
        >
            <div>
                <img src={image} alt="" className={classes.game__image} />
            </div>
            <div className={classes.wrap__provider}>
                <span className={classes.provider__text}>{provider}</span>
                <span className={is_disabled ? classes.status__error : classes.status__success}>
                    {is_disabled ? 'Отключена' : 'Включена'}
                </span>
            </div>
            <div>
                <span className={classes.game__name}>{name}</span>
            </div>
        </div>
    )
}

export default GameItem;